import * as runtime from '../runtime';
import { IInitializeServiceOptions } from '../types';
import {
	IGenerateTokenRequest,
	IGenerateTokenResponse,
	IGetConnectionRequest,
	IGetConnectionResponse,
	IGetRegistrationRequest,
	IGetRegistrationResponse,
} from './models';

export class FabricBEService extends runtime.BaseAPI {
	constructor(configuration: runtime.Configuration) {
		super(configuration);
	}

	async getConnectionRaw(
		requestParameters: IGetConnectionRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<IGetConnectionResponse>> {
		if (!requestParameters.connectionId) {
			throw new runtime.RequiredError('connectionId', 'Required parameter requestParameters.connectionId was null or undefined when calling getSchedule.');
		}

		if (!requestParameters.workspaceId) {
			throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling getSchedule.');
		}

		if (!requestParameters.connectionType) {
			throw new runtime.RequiredError('connectionType', 'Required parameter requestParameters.connectionType was null or undefined when calling getSchedule.');
		}

		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};
		headerParameters['Content-Type'] = 'application/json';

		const response = await this.request(
			{
				path: `/api/v1/authentication/connectionSetup`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: { ...requestParameters },
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	async getConnection(requestParameters: IGetConnectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IGetConnectionResponse> {
		const response = await this.getConnectionRaw(requestParameters, initOverrides);
		return await response.value();
	}

	async getRegistrationRaw(
		requestParameters: IGetRegistrationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<IGetRegistrationResponse>> {
		if (!requestParameters.accessToken) {
			throw new runtime.RequiredError('accessToken', 'Required parameter requestParameters.accessToken was null or undefined when calling getSchedule.');
		}

		if (!requestParameters.workspaceId) {
			throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling getSchedule.');
		}

		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};
		headerParameters['Content-Type'] = 'application/json';

		const response = await this.request(
			{
				path: `/api/v1/authentication/register`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: { ...requestParameters },
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	async getRegistration(
		requestParameters: IGetRegistrationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<IGetRegistrationResponse> {
		const response = await this.getRegistrationRaw(requestParameters, initOverrides);
		return await response.value();
	}

	async generateTokenRaw(
		requestParameters: IGenerateTokenRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<IGenerateTokenResponse>> {
		if (!requestParameters.accessToken) {
			throw new runtime.RequiredError('accessToken', 'Required parameter requestParameters.accessToken was null or undefined when calling getSchedule.');
		}

		if (!requestParameters.workspaceId) {
			throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling getSchedule.');
		}

		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};
		headerParameters['Content-Type'] = 'application/json';

		const response = await this.request(
			{
				path: `/api/v1/authentication/generateToken`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: { ...requestParameters },
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	async generateToken(requestParameters: IGenerateTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IGenerateTokenResponse> {
		const response = await this.generateTokenRaw(requestParameters, initOverrides);
		return await response.value();
	}
}

export const initializeFabricBEService = ({ fetchApi }: Pick<IInitializeServiceOptions, 'fetchApi'>) => {
	const scheduleService = new FabricBEService(
		new runtime.Configuration({
			fetchApi,
			basePath: '/be-workload',
		}),
	);
	return scheduleService;
};
